import { render, staticRenderFns } from "./CustomerBatchUploads.vue?vue&type=template&id=5afed8dc&"
import script from "./CustomerBatchUploads.vue?vue&type=script&lang=ts&"
export * from "./CustomerBatchUploads.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports